import { PagedData } from '@/Interfaces/_';
import { UserGroupResponse, UserResponse } from '@/Interfaces/I_userGroup';

import { customAxios } from '../index';

const BASE_URL = '/hktv_koc/cms';

// User Group endpoints
export function getAllUserGroups(params?: { search?: string; page?: number; size?: number }) {
  const query = [];
  if (params?.search) query.push(`search=${encodeURIComponent(params.search)}`);
  if (typeof params?.page === 'number') query.push(`page=${params.page}`);
  if (typeof params?.size === 'number') query.push(`size=${params.size}`);
  const queryString = query.length ? `?${query.join('&')}` : '';
  return customAxios.get<PagedData<UserGroupResponse>>(`${BASE_URL}/user_groups${queryString}`);
}

export function getUserGroup(id: number) {
  return customAxios.get<UserGroupResponse>(`${BASE_URL}/user_groups/${id}`);
}

export function createUserGroup(data: { name: string; description: string }) {
  return customAxios.post<UserGroupResponse>(`${BASE_URL}/user_groups`, data);
}

export function updateUserGroup(id: number, data: { name: string; description: string }) {
  return customAxios.put<UserGroupResponse>(`${BASE_URL}/user_groups/${id}`, data);
}

export function deleteUserGroup(id: number) {
  return customAxios.delete(`${BASE_URL}/user_groups/${id}`);
}

// User Group Users endpoints
export function getUserGroupUsers(id: number) {
  return customAxios.get<UserResponse[]>(`${BASE_URL}/user_groups/${id}/users`);
}

export function addUserToUserGroup(id: number, userId: number) {
  return customAxios.post(`${BASE_URL}/user_groups/${id}/users/${userId}`);
}

export function removeUserFromUserGroup(id: number, userId: number) {
  return customAxios.delete(`${BASE_URL}/user_groups/${id}/users/${userId}`);
}
